import { Log } from "../../../types/usage/log";
import { HttpClient } from "../http-client";

const LOGS_BASE_URL = 'https://api.centsdonations.com/v2/tap-to-donate'
export class LogsClient {

  private readonly httpClient

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient
  }

  async log(data: Log | Log[]): Promise<void> {
    const response = await this.httpClient.fetch(`${LOGS_BASE_URL}/logs`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    })
    if (!response.ok) {
      throw new Error(`Error while sending log: ${response.status}`)
    }
    return await response.json()
  }
}
